module.exports = __webpack_public_path__ + "media/images/emblems/Bueron_LU-ac0966ac7c9b620850d20fc95df015cb.png";